export default __webpack_public_path__ + "static/media/fr_ad_banner.2cd09b5f.jpg";